import { cloneQuery } from '@esentai/core/queries';

export default () => (state, { payload: page }) => {
  const queryClone = cloneQuery(state);

  queryClone.set('page', page);

  return queryClone;
};
